export function SpeedKmh({ speed }: { speed: string }): JSX.Element {
  if (speed === undefined) return <>-</>;
  return <>{speed} km/h</>;
}
